// Formatta la data di sblocco di un badge.
// long=false → "12 mar" · long=true → "12 marzo 2026"
export function formatBadgeDate(iso, long = false) {
  if (!iso) return '';
  try {
    return new Intl.DateTimeFormat('it-IT', {
      day: 'numeric',
      month: long ? 'long' : 'short',
      year: long ? 'numeric' : undefined,
    }).format(new Date(iso));
  } catch {
    return '';
  }
}
